// Spec: docs/705-frontend-dashboard-system-plan.md
// Agent: /AGENTS.md#spec-workflow
import React from 'react';
import ReactDOM from 'react-dom/client';

import App from './App';
import './index.css';
import { installPortalSessionExpiryInterceptor } from './lib/session-expiry';

installPortalSessionExpiryInterceptor();

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
